module.exports = __webpack_public_path__ + "static/media/hero-2.d0ab4cde.png";